@if (isSafari) {
  @if (showSearch()) {
    <!-- Searchable variant for Safari -->
    <div
      class="native-search-select-wrapper"
      [class.selected]="selectedClass()"
    >
      <input
        #searchInput
        type="text"
        class="native-search-input"
        [class.selected]="selectedClass()"
        [disabled]="isDisabled"
        [placeholder]="selectedLabel || placeholder()"
        [value]="dropdownOpen() ? searchText() : selectedLabel"
        (input)="searchText.set($any($event.target).value)"
        (click)="openDropdown()"
        autocomplete="off"
      />
      @if (allowClear() && selectedLabel) {
        <button
          type="button"
          class="native-clear-btn"
          (click)="onClear()"
          aria-label="Clear selection"
        >
          <i nz-icon [nzType]="'icons:exit'" class="native-clear-icon"></i>
        </button>
      }
      @if (dropdownOpen()) {
        <ul class="native-search-dropdown">
          @for (option of filteredOptions(); track $index) {
            <li
              class="native-search-option"
              [class.disabled]="option.disabled"
              (mousedown)="!option.disabled && selectSearchOption(option)"
            >
              {{ option.label }}
            </li>
          }
          @if (filteredOptions().length === 0) {
            <li class="native-search-option no-results">No results</li>
          }
        </ul>
      }
    </div>
  } @else {
    <!-- Plain native select for Safari (no search) -->
    <div class="native-select-wrapper">
      <select
        [class.selected]="selectedClass()"
        [disabled]="isDisabled"
        [value]="getNativeSelectedIndex()"
        (change)="onNativeChange($event)"
      >
        @if (placeholder()) {
          <option value="-1" disabled hidden>{{ placeholder() }}</option>
        }
        @for (option of options(); track $index) {
          @if (!option.hidden) {
            <option [value]="$index" [disabled]="option.disabled ?? false">
              {{ option.label }}
            </option>
          }
        }
      </select>
      @if (allowClear() && getNativeSelectedIndex() >= 0) {
        <button
          type="button"
          class="native-clear-btn"
          (click)="onClear()"
          aria-label="Clear selection"
        >
          <i nz-icon [nzType]="'icons:exit'" class="native-clear-icon"></i>
        </button>
      }
    </div>
  }
} @else {
  <nz-select
    [nzShowSearch]="showSearch()"
    #selectRef
    [class.selected]="selectedClass()"
    [nzPlaceHolder]="placeholder()"
    [nzCustomTemplate]="customTemplate"
    [nzShowArrow]="false"
    [nzAllowClear]="allowClear()"
    [nzDisabled]="isDisabled"
    [ngModel]="value()"
    [compareWith]="compareWith()"
    (ngModelChange)="onNzChange($event)"
    [nzDropdownClassName]="'safe-select-dropdown'"
    [nzDropdownStyle]="{ 'border-radius': '12px' }"
  >
    @for (option of options(); track $index) {
      <nz-option
        [nzValue]="option.value"
        [nzLabel]="option.label"
        [nzDisabled]="option.disabled ?? false"
        [nzHide]="option.hidden ?? false"
      ></nz-option>
    }
  </nz-select>

  <ng-template #customTemplate let-selected>
    <div class="customSelectBox">
      <span>{{ selected.nzLabel }}</span>
    </div>
  </ng-template>
}
